import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Create, FileCopySharp, Visibility } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import { Link } from 'react-router-dom';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsFindBy } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'Periodo', width: 150 },
  { Header: 'Zona', accessor: 'zona', width: 150 },
  { Header: 'Proveedor', accessor: 'CardCode', width: 150 },
  { Header: 'Proveedor', accessor: 'CardName'},
  { Header: 'Marca', accessor: 'mark', width: 150 },
  { Header: 'Vendedor', accessor: 'seller' },
  { Header: 'Cód. Cartera', accessor: 'codPortfolio', width: 160 },
  { Header: 'Mesa', accessor: 'bureau', width: 140 },
  { Header: 'Cuota', accessor: 'cuota', width: 130 },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function Config(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [config, setConfig] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [valueSearch, setValueSearch] = useState({});

  async function loadConfig(filter) {
    setDataLoading(true);
    let response = await wsFindBy('quota/quota-group',filter);
    setDataLoading(false);
    if (response.success) setConfig(response.data);
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadConfig(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Cuotas {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadConfig}
              getValueSearch={(value) => {
                setValueSearch(value);
              }}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="Periodo"
              zone
              mark
            />
            <ReactTable
              excelName="cuotas"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={config.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA} >
                        <ButtonDelete
                          entity="quota/quota-group"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            loadConfig(valueSearch).then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  Periodo: item.Periodo,
                  zona: item.zone?.description,
                  CardCode: item.provider?.CardCode,
                  CardName: item.provider?.CardName,
                  mark: item.mark?.description,
                  seller: item.seller?.SlpName,
                  codPortfolio: item.portfolio?.code,
                  bureau: item.bureau?.description,
                  cuota: item.cuota,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
